<template>
  <transition name="slide">
    <section class="ghnotification-wrap" v-if="show">
      <div class="title" v-if="title">
        <img src="./images/success.svg" v-if="mode == 'success'" />
        <span>{{title}}</span>
        <div class="countdown">{{countdown}}S 后自动关闭</div>
      </div>
      <div class="content-wrap">
        <div class="content" v-if="content">
          <span>{{ content }}</span>
        </div>
        <slot></slot>
      </div>
    </section>
  </transition>
</template>

<script setup>
  import { onMounted, ref, watch } from "vue";

  const emit = defineEmits(['close']);

  const props = defineProps({
    mode: {
      type: String,
      default: 'success'
    },
    title: {
      type: String,
      default: ''
    },
    show: {
      type: Boolean,
      default: false
    },
    content: {
      type: String,
      default: ''
    }
  })

  const countdown = ref(10);
  let countdownTimer = null;
  const countDownAction = () => {
    clearTimeout(countdownTimer)
    countdownTimer = null;
    if(countdown.value <= 0) {
      emit('close');
      return;
    }
    countdown.value -= 1;

    countdownTimer = setTimeout(() => {
      countDownAction();
    }, 1000);
  }

  const init = () => {
    countdown.value = 11;
    countDownAction()
  }
  onMounted(() => {
    init();
  })
  watch(() => props.show, () => {
    if(props.show) {
      init();
    }
  })
</script>

<style scoped lang="less">
@import "./index.less";
</style>
